/* ─── Contact form → POST /api/contactus ────────────────────────────── */
'use strict';

(function () {
  const form    = document.getElementById('contact-form');
  const submit  = document.getElementById('contact-submit');
  const success = document.getElementById('form-success');
  const error   = document.getElementById('form-error');

  if (!form || !submit || !success || !error) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    /* Collect and trim values */
    const name    = (form.querySelector('#field-name')?.value    ?? '').trim();
    const email   = (form.querySelector('#field-email')?.value   ?? '').trim();
    const phone   = (form.querySelector('#field-phone')?.value   ?? '').trim();
    const message = (form.querySelector('#field-message')?.value ?? '').trim();

    /* Client-side validation */
    if (!phone) {
      showError('Please enter your phone number.');
      return;
    }
    if (!message) {
      showError('Please tell us a bit about your product.');
      return;
    }

    /* Reset feedback */
    hideAll();
    submit.disabled = true;
    submit.textContent = 'Sending…';

    try {
      const res = await fetch('/api/contactus', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, phone, message }),
      });

      if (res.ok) {
        form.reset();
        success.classList.add('is-visible');
        success.focus();
      } else {
        showError('Something went wrong. Please try again or email us directly.');
      }
    } catch (_err) {
      showError('Network error. Please check your connection and try again.');
    } finally {
      submit.disabled = false;
      submit.textContent = 'Send Message';
    }
  });

  function showError(msg) {
    error.textContent = msg;
    error.classList.add('is-visible');
    error.focus();
  }

  function hideAll() {
    success.classList.remove('is-visible');
    error.classList.remove('is-visible');
  }
})();
